module.exports = __webpack_public_path__ + "img/icon-mango.8ae85ec7.png";